import React, { useContext, useState } from "react";
import "./DigitalTheme1.css";
import { IoMdCall } from "react-icons/io";
import { TfiAnnouncement } from "react-icons/tfi";
import { BsLink } from "react-icons/bs";
import { RiGalleryLine } from "react-icons/ri";
import { MdReviews } from "react-icons/md";
import { FaExchangeAlt, FaFileDownload } from "react-icons/fa";
import Website from "../Common/websiteCards/Website";
import Review from "../Common/reviewCards/Reviews";
import Downloads from "../Common/fileDownloadsCards/Downloads";
import HighlightImage from "../Common/highlightImagesCards/HighlightImage";
import ProfileCard from "../Common/profileCards/ProfileCard";
import ContactCard1 from "../Common/contactCards/ContactCard1";
import ContactCardDigit from "../Common/contactCards/ContactCardDigit";
import ListSocialMedia from "../Common/socialMedia/ListSocialMedia";
import { HighlightImageValid, SocialMediaValid } from "../Common/DivValidation";
import QRModal from "../Common/qrModals/QRModal";
import { CardContext } from "../../store/CardContext";
import ListSocialMedias from "../Common/socialMedia/ListSocialMedias";
import ExchangeContact from "../Common/exchangeContactModal/ExchangeContact";
import Footer from "../Common/footer/Footer";
import { FaUser } from "react-icons/fa";
import { TbArrowsExchange } from "react-icons/tb";
import { Link } from "react-router-dom";
import { IoShareSocialOutline } from "react-icons/io5";
import { IoCloseOutline, IoLink } from "react-icons/io5";
import { BsQrCodeScan } from "react-icons/bs";
import ProfileCardDigit from "../Common/profileCards/ProfileCardDigit";

const defaultBackgroundImage =
  // "https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultBackground.jpg";
  "https://metatestbucket.s3.ap-south-1.amazonaws.com/assets/zeeqr-logo.png"
const defaultProfileImage =
  "https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultProfile.jpg";

function DigitalTheme1({ color, card, preview }) {
  const [cardData] = useContext(CardContext);
  const {
    backgroundImage,
    website,
    review,
    fileName,
    files,
    checkProfile,
    checkPfCard,
    footerText,
  } = cardData;
  const [isOpen, setIsOpen] = useState(false);

  const toggleButtons = () => {
    setIsOpen(!isOpen);
  };
  const [activeTab, setActiveTab] = useState(1);
  const [qrModal, setQrModal] = useState(false);

  const Highlightcolor = card?.colorCode ? card?.colorCode : "#19D3DA";
  const Textcolor = card?.textColor ? card?.textColor : "#FFFFFF";
  const Iconcolor = card?.iconBgColor ? card?.iconBgColor : "#12171B";
  // const BgColor = card?.bgColor ? card?.bgColor : "";
  const BtIColor = card?.btIconColor ? card?.btIconColor : "#777777";
  const iconColor = color ? color : "#FFFFFF";

  const SocialMediaImageCheck = SocialMediaValid();
  const HighlightImageCheck = HighlightImageValid();
  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          text: "Please check it out.",
          url: window.location.href,
          title: "ZeeQR",
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    }
  };

 
  const [showResults, setShowResults] = useState(false);
  const onClick = () => setShowResults(true);
  const handleClose = (e) => {
    setQrModal(false);
    setShowResults(false);
  };

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };
  const exchangeButton = (
    <span className="flex items-center justify-center h-14 w-[60px] md:w-[60px] border  bg-white rounded-[10px] px-4 relative">
      <FaExchangeAlt size={18} color="black" />
    </span>
  );

  const BgColor = card?.bgColor ? card?.bgColor : "#1A1F23";
  const imageStyle = {
    backgroundSize: card?.bgImgType ? card?.bgImgType : "cover",
    backgroundPosition: "center ",
    backgroundImage: `url(${card?.bgImg})`,
    backgroundRepeat: card?.bgImgRepeat ? card?.bgImgRepeat : "no-repeat",

  };
  const colorStyle = {
    backgroundSize: "100%",
    backgroundPosition: "center 150px",
    backgroundColor: BgColor,
  };
  const defaultStyle = {
    backgroundSize: "100%",
    backgroundPosition: "center 150px",
    backgroundImage: 'white'
  };
  
  return (
    <>
      <div className="previewWrapdigital_1 " >
        <div className="bannerImagedigital_1">
          {backgroundImage ? (
            <img src={backgroundImage} alt="" />
          ) : (
            <img src={defaultBackgroundImage} alt="" />
          )}
        </div>
        {card?.checkLogo ? (
                        <div className="flex items-center justify-center">
                <div className="companyLogo absolute top-10  w-32 ">
                  {card?.companyLogo ? (
                    <img className="object-contain" src={card?.companyLogo} alt="" />
                  ) : (
                    <img src={defaultBackgroundImage} alt="" />
                  )}
                </div>
                </div>
              ) : (
                ""
              )}
        <div
          className="previewContainerdigital_1 " style={card?.bgImg ? imageStyle : BgColor ? colorStyle : defaultStyle}
        // className="previewContainerdigital_1  bg-[#1A1F23] "
        // style={{ color: `${color === "black" ? "white" : "black"}` }}
        >
          {checkPfCard ? (
            <ProfileCardDigit
              Highlightcolor={Highlightcolor}
              Textcolor={Textcolor}
              theme={"digital"}
              card={card}
              preview={preview}
            />
          ) : (
            ""
          )}

          <div className="flex ">
            <div className="w-[65px] bg-[#12171B] pl-4">
              <ul className="text-[30px]  sticky top-0 ">
                <li
                  className={`mb-2 w-[49px] h-[60px] ${activeTab === 1
                    ? "font-bold text-black border-r-4 flex items-center"
                    : "text-[#AFAFAF] flex items-center"
                    }`}
                  onClick={() => handleTabClick(1)}
                  style={
                    activeTab === 1
                      ? { borderColor: Highlightcolor || "#00000" }
                      : {}
                  }
                >
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.95385 25C4.37757 22.9133 5.50966 21.0373 7.15831 19.6898C8.80695 18.3422 10.8707 17.6061 13 17.6061C15.1293 17.6061 17.1931 18.3422 18.8417 19.6898C20.4904 21.0373 21.6225 22.9133 22.0462 25M17.6154 10.2308C17.6154 12.7798 15.549 14.8462 13 14.8462C10.451 14.8462 8.38463 12.7798 8.38463 10.2308C8.38463 7.68176 10.451 5.61538 13 5.61538C15.549 5.61538 17.6154 7.68176 17.6154 10.2308ZM2.84616 1H23.1539C24.1735 1 25.0001 1.82655 25.0001 2.84615V23.1538C25.0001 24.1734 24.1735 25 23.1539 25H2.84616C1.82655 25 1 24.1734 1 23.1538V2.84615C1 1.82655 1.82655 1 2.84616 1Z"
                      stroke={
                        activeTab === 1
                          ? `${Highlightcolor || "#FF0000"}`
                          : "#777777"
                      }
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </li>

                {SocialMediaImageCheck ||
                  (card?.socialMedias && card?.socialMedias?.length !== 0) ? (
                  <li
                    className={`mb-2 w-[49px] h-[60px] ${activeTab === 2
                      ? "font-bold text-black  flex items-center border-r-4   "
                      : "text-[#AFAFAF]  flex items-center"
                      }`}
                    onClick={() => handleTabClick(2)}
                    style={
                      activeTab === 2
                        ? { borderColor: Highlightcolor || "#00000" }
                        : {}
                    }
                  >
                    <svg
                      width="26"
                      height="27"
                      viewBox="0 0 26 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.51449 21.9855C2.83616 20.3073 1.69319 18.1691 1.23012 15.8412C0.767057 13.5134 1.0047 11.1005 1.91299 8.90773C2.82129 6.71495 4.35943 4.84077 6.33292 3.5222C8.3064 2.20363 10.6266 1.4999 13 1.5M21.4856 5.01446C23.1639 6.69269 24.3069 8.83094 24.7699 11.1588C25.233 13.4866 24.9954 15.8995 24.0871 18.0923C23.1788 20.285 21.6406 22.1592 19.6671 23.4778C17.6937 24.7964 15.3735 25.5001 13 25.5M10.4597 11.2225L12.4062 15.1148M10.4597 11.2225L15.0006 6.68154L18.8923 14.4662L12.4062 15.1148M10.4597 11.2225L7.86526 12.5197C7.08557 12.9092 7.15142 14.3351 7.54095 15.1148C7.93049 15.8945 9.03203 16.8015 9.81172 16.412L12.4062 15.1148M11.8326 15.4458L13.4542 18.6889L12.157 19.3375L10.5354 16.0945M21.5945 4.25692C21.5945 5.33158 20.7233 6.20277 19.6486 6.20277C18.574 6.20277 17.7028 5.33158 17.7028 4.25692C17.7028 3.18226 18.574 2.31108 19.6486 2.31108C20.7233 2.31108 21.5945 3.18226 21.5945 4.25692ZM8.29726 22.7431C8.29726 23.8177 7.42608 24.6889 6.35142 24.6889C5.27676 24.6889 4.40557 23.8177 4.40557 22.7431C4.40557 21.6684 5.27676 20.7972 6.35142 20.7972C7.42608 20.7972 8.29726 21.6684 8.29726 22.7431Z"
                        stroke={
                          activeTab === 2
                            ? `${Highlightcolor || "#FF0000"}`
                            : "#777777"
                        }
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </li>
                ) : (
                  ""
                )}

                {website[0]?.websiteName ? (
                  <li
                    className={`mb-2 w-[49px] h-[60px] ${activeTab === 3
                      ? "font-bold text-black border-r-4  flex items-center "
                      : "text-[#AFAFAF]  flex items-center"
                      }`}
                    onClick={() => handleTabClick(3)}
                    style={
                      activeTab === 3
                        ? { borderColor: Highlightcolor || "#00000" }
                        : {}
                    }
                  >
                    <svg
                      width="24"
                      height="12"
                      viewBox="0 0 24 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.28 6C2.28 3.948 3.948 2.28 6 2.28H10.8V0H6C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12H10.8V9.72H6C3.948 9.72 2.28 8.052 2.28 6ZM7.2 7.2H16.8V4.8H7.2V7.2ZM18 0H13.2V2.28H18C20.052 2.28 21.72 3.948 21.72 6C21.72 8.052 20.052 9.72 18 9.72H13.2V12H18C21.312 12 24 9.312 24 6C24 2.688 21.312 0 18 0Z"
                        fill={
                          activeTab === 3
                            ? `${Highlightcolor || "#FF0000"}`
                            : "#777777"
                        }
                      />
                    </svg>
                  </li>
                ) : (
                  ""
                )}
                {review[0]?.reviewName ? (
                  <li
                    className={`mb-2 w-[49px] h-[60px] ${activeTab === 4
                      ? "font-bold text-black border-r-4  flex items-center border-[#FF0000]"
                      : "text-[#AFAFAF]  flex items-center"
                      }`}
                    onClick={() => handleTabClick(4)}
                    style={
                      activeTab === 4
                        ? { borderColor: Highlightcolor || "#00000" }
                        : {}
                    }
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.99914 20.4951L12.0008 17.3209L17.0024 20.5368L15.6925 14.5226L20.0987 10.5132L14.3031 9.97021L12.0008 4.29013L9.69845 9.92844L3.90288 10.4714L8.3091 14.5226L6.99914 20.4951ZM4.5777 24L6.54661 15.124L0 9.15662L8.62349 8.37143L12.0008 0L15.3781 8.36976L24 9.15495L17.4534 15.1224L19.4239 23.9983L12.0008 19.2872L4.5777 24Z"
                        fill={
                          activeTab === 4
                            ? `${Highlightcolor || "#FF0000"}`
                            : "#777777"
                        }
                      />
                    </svg>
                  </li>
                ) : (
                  ""
                )}
                {fileName?.fileName1 ||
                  fileName?.fileName2 ||
                  fileName?.fileName3 ||
                  fileName?.fileName4 ? (
                  <li
                    className={`mb-2 w-[49px] h-[60px] ${activeTab === 5
                      ? "font-bold text-black  flex items-center border-r-4"
                      : "text-[#AFAFAF]  flex items-center"
                      }`}
                    onClick={() => handleTabClick(5)}
                    style={
                      activeTab === 5
                        ? { borderColor: Highlightcolor || "#00000" }
                        : {}
                    }
                  >
                    <svg
                      width="22"
                      height="27"
                      viewBox="0 0 22 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.3332 1.5V9.5H20.3332M4.33317 25.5C3.62593 25.5 2.94765 25.219 2.44755 24.719C1.94746 24.2189 1.6665 23.5406 1.6665 22.8333V1.5H13.6665L20.3332 8.16667V22.8333C20.3332 23.5406 20.0522 24.2189 19.5521 24.719C19.052 25.219 18.3737 25.5 17.6665 25.5H4.33317Z"
                        stroke={
                          activeTab === 5
                            ? `${Highlightcolor || "#FF0000"}`
                            : "#777777"
                        }
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </li>
                ) : (
                  ""
                )}
                {HighlightImageCheck ? (
                  <li
                    className={`mb-2 w-[49px] h-[60px] ${activeTab === 6
                      ? "font-bold text-black  flex items-center border-r-4 "
                      : "text-[#AFAFAF]  flex items-center"
                      }`}
                    onClick={() => handleTabClick(6)}
                    style={
                      activeTab === 6
                        ? { borderColor: Highlightcolor || "#00000" }
                        : {}
                    }
                  >
                    <svg
                      width="26"
                      height="24"
                      viewBox="0 0 26 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 17.5385V3.69234C1 3.20271 1.1945 2.73314 1.54073 2.38692C1.88695 2.0407 2.35652 1.84619 2.84615 1.84619H19.4615M6.72308 22.0061L13.9785 14.3446C14.1501 14.156 14.3589 14.0051 14.5917 13.9012C14.8245 13.7973 15.0764 13.7428 15.3313 13.741C15.5863 13.7393 15.8389 13.7904 16.0731 13.8911C16.3073 13.9918 16.5182 14.1399 16.6923 14.3262L23.9846 21.9692M23.1538 22.1538H7.46154C6.44194 22.1538 5.61539 21.3273 5.61539 20.3077V8.30771C5.61539 7.28811 6.44194 6.46157 7.46154 6.46157H23.1538C24.1734 6.46157 25 7.28811 25 8.30771V20.3077C25 21.3273 24.1734 22.1538 23.1538 22.1538Z"
                        stroke={
                          activeTab === 6
                            ? `${Highlightcolor || "#FF0000"}`
                            : "#777777"
                        }
                        stroke-width="1.84615"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </li>
                ) : (
                  ""
                )}
                {/* <li
                  className={`mb-2 w-[49px] h-[60px] ${
                    activeTab === 7
                      ? "font-bold text-black border-r-4 border-[#FF0000]"
                      : "text-[#AFAFAF]"
                  }`}
                  onClick={() => handleTabClick(5)}
                >
                  <BsFillCameraVideoFill />
                </li> */}
              </ul>
            </div>

            {/* Display the content based on the activeTab state */}
            <div
              className={`w-full min-h-[${checkPfCard && checkProfile ? "380px" : "440px"
                }]`}
              style={{
                marginBottom: "100px",
                //  backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`
              }}
            >
              {/* ------------------------------- Basic Info ------------------------------- */}
              {activeTab === 1 && (
                <div className="ml-3">
                  <ContactCardDigit
                    preview={preview}
                    Highlightcolor={Highlightcolor}
                    Textcolor={Textcolor}
                    Iconcolor={Iconcolor}
                    BtIColor={BtIColor}
                    card={card}
                  />
                </div>
              )}
              {/* ------------------------------- socialMediaDetails ------------------------------- */}
              {preview ? (
                <div>
                  {activeTab === 2 && (
                    <div className=" mx-2 ">
                      {/* <SocialMedia data={data} /> */}
                      {card?.socialMedias &&
                        card?.socialMedias?.length !== 0 ? (
                        <ListSocialMedias

                          preview={preview}
                          Textcolor={Textcolor}
                          BtIColor={BtIColor}
                          Iconcolor={Iconcolor}
                        />
                      ) : (
                        <ListSocialMedia preview={preview} Textcolor={Textcolor} BtIColor={BtIColor} Iconcolor={Iconcolor} />
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  {activeTab === 2 && (
                    <div className=" mx-2 ">
                      {/* <SocialMedia data={data} /> */}
                      {card?.socialMedias &&
                        card?.socialMedias?.length !== 0 ? (
                        <ListSocialMedias preview={preview} Textcolor={Textcolor} BtIColor={BtIColor} Iconcolor={Iconcolor} />
                      ) : (
                        <ListSocialMedia preview={preview} Textcolor={Textcolor} BtIColor={BtIColor} Iconcolor={Iconcolor} />
                      )}
                    </div>
                  )}
                </div>
              )}
              {/* ------------------------------- Website ------------------------------- */}
              {preview ? (
                <div>
                  {activeTab === 3 && (
                    <div>
                      <div className="   text-white p-[6px]   rounded-[12px] ">
                        <Website
                          website={website}
                          preview={preview}
                          Textcolor={Textcolor}
                          BtIColor={BtIColor}
                          Iconcolor={Iconcolor}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  {activeTab === 3 && (
                    <div>
                      <div className="   text-white p-[6px]  rounded-[12px] ">
                        <Website
                          website={website}
                          preview={preview}
                          Textcolor={Textcolor}
                          BtIColor={BtIColor}
                          Iconcolor={Iconcolor}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* ------------------------------- Review ------------------------------- */}
              {preview ? (
                <div>
                  {activeTab === 4 && (
                    <div>
                      <div className="  text-white p-[6px] rounded-[12px] ">
                        <Review
                          review={review}
                          preview={preview}
                          Textcolor={Textcolor}
                          BtIColor={BtIColor}
                          Iconcolor={Iconcolor}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  {activeTab === 4 && (
                    <div>
                      <div className="   text-white p-[6px] rounded-[12px] ">
                        <Review
                          review={review}
                          preview={preview}
                          Textcolor={Textcolor}
                          BtIColor={BtIColor}
                          Iconcolor={Iconcolor}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* ------------------------------- Downloads ------------------------------- */}
              {preview ? (
                <div>
                  {activeTab === 5 && (
                    <div>
                      <div className="  text-white p-[6px]  rounded-[12px] ">
                        <Downloads
                          files={files}
                          fileName={fileName}
                          preview={preview}
                          Textcolor={Textcolor}
                          Highlightcolor={Highlightcolor}
                          BtIColor={BtIColor}
                          Iconcolor={Iconcolor}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  {activeTab === 5 && (
                    <div>
                      <div className="text-white p-[6px]  rounded-[12px] ">
                        <Downloads
                          files={files}
                          fileName={fileName}
                          preview={preview}
                          Textcolor={Textcolor}
                          Highlightcolor={Highlightcolor}
                          BtIColor={BtIColor}
                          Iconcolor={Iconcolor}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {activeTab === 6 && (
                <div>
                  <div className="    text-white p-[6px]  rounded-[12px] ">
                    <div className="grid grid-rows-2 grid-flow-col gap-4  ">
                      <HighlightImage />
                    </div>
                  </div>
                </div>
              )}
              {activeTab === 7 && (
                <div>
                  <div className="   text-white p-[6px]  rounded-[12px] ">
                    <div className="grid  gap-4  ">
                      <img
                        src={defaultProfileImage}
                        alt="profile_interfacevideoimg"
                      ></img>
                      <img
                        src={defaultProfileImage}
                        alt="profile_interfacevideoimg"
                      ></img>
                    </div>
                  </div>
                </div>
              )}
              {preview ? (
                <div className="fixed bottom-0 right-7 z-10 space-y-4">
                  {!isOpen && (
                    <div className="relative group">
                      <div className="flex items-center space-x-2">
                        <span
                          className="absolute -left-12 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                          style={{
                            color: `${Highlightcolor ? Highlightcolor : ""}`,
                          }}
                        >
                          Share
                        </span>
                        <button
                          onClick={toggleButtons}
                          className="border rounded-full p-2 bg-blue-500 hover:bg-blue-600 transition-transform duration-[1s] ease-in-out"
                          style={{
                            backgroundColor: `${Highlightcolor ? Highlightcolor : ""
                              }`,
                            borderColor: `${Highlightcolor ? Highlightcolor : ""
                              }`,
                          }}
                        >
                          <IoShareSocialOutline size={23} color={iconColor} />
                        </button>
                      </div>
                    </div>
                  )}

                  {isOpen && (
                    <>
                      {/* Profile Link Button */}
                      <div
                        className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen
                          ? "opacity-100 translate-y-0"
                          : "opacity-0 translate-y-8"
                          }`}
                        style={{ transitionDelay: "0.1s" }}
                      >
                        <div className="flex items-center space-x-2">
                          <span
                            className="absolute -left-24 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                            style={{
                              color: `${Highlightcolor ? Highlightcolor : ""}`,
                            }}
                          >
                            Profile Link
                          </span>
                          <button
                            onClick={handleShare}
                            className="border-[1px] rounded-full p-2 bg-transparent transition-transform duration-[1s] ease-in-out"
                            style={{
                              color: `${Highlightcolor ? Highlightcolor : ""}`,
                              borderColor: `${Highlightcolor ? Highlightcolor : ""
                                }`,
                            }}
                          >
                            <IoLink size={23} />
                          </button>
                        </div>
                      </div>

                      {/* QR Code Button */}
                      <div
                        className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen
                          ? "opacity-100 translate-y-0"
                          : "opacity-0 translate-y-8"
                          }`}
                        style={{ transitionDelay: "0.2s" }}
                      >
                        <div className="flex items-center space-x-2">
                          <span
                            className="absolute -left-16 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                            style={{
                              color: `${Highlightcolor ? Highlightcolor : ""}`,
                            }}
                          >
                            QR Code
                          </span>
                          <button
                            onClick={() => setQrModal(true)}
                            className="border-[1px] rounded-full p-2 bg-transparent transition-transform duration-[1s] ease-in-out"
                            style={{
                              borderColor: `${Highlightcolor ? Highlightcolor : ""
                                }`,
                            }}
                          >
                            <BsQrCodeScan
                              size={23}
                              style={{
                                color: `${Highlightcolor ? Highlightcolor : ""
                                  }`,
                              }}
                            />
                          </button>
                        </div>
                      </div>

                      {/* Close Button */}
                      <div
                        className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen
                          ? "opacity-100 translate-y-0"
                          : "opacity-0 translate-y-8"
                          }`}
                        style={{ transitionDelay: "0.3s" }}
                      >
                        <div className="flex items-center space-x-2">
                          <span
                            className="absolute -left-12 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                            style={{
                              color: `${Highlightcolor ? Highlightcolor : ""}`,
                            }}
                          >
                            Close
                          </span>
                          <button
                            onClick={toggleButtons}
                            className="border rounded-full p-2 text-white cursor-pointer transition-transform duration-[1s] ease-in-out"
                            style={{
                              backgroundColor: `${Highlightcolor ? Highlightcolor : ""
                                }`,
                              borderColor: `${Highlightcolor ? Highlightcolor : ""
                                }`,
                            }}
                          >
                            <IoCloseOutline size={23} color={iconColor} />
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              ) : (
                // <div className="flex justify-center gap-[20px] fixed top-[90%] lg:left-[45%] left-[35%]   ">
                //   <button
                //     className="w-[50px] h-[50px] flex justify-center p-[15px] rounded-[12px] shadow bg-white"
                //     onClick={handleShare}
                //   >
                //     <svg
                //       width="24"
                //       height="24"
                //       viewBox="0 0 24 24"
                //       fill="none"
                //       xmlns="http://www.w3.org/2000/svg"
                //     >
                //       <path
                //         d="M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7623 15.025 18.637C15.0417 18.5117 15.0667 18.3993 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.646 7.1 14.788C6.75 14.93 6.38333 15.0007 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.071 7.1 9.213C7.45 9.355 7.76667 9.55067 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.48767 15.025 5.363C15.0083 5.23833 15 5.11733 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92933 16.9 7.788C16.55 7.64667 16.2333 7.45067 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5127 8.975 11.638C8.99167 11.7633 9 11.884 9 12C9 12.1167 8.99167 12.2377 8.975 12.363C8.95833 12.4883 8.93333 12.6007 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3543 16.9 16.213C17.25 16.0717 17.6167 16.0007 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22Z"
                //         fill="black"
                //       />
                //     </svg>
                //   </button>
                //   <button
                //     className="w-[50px] h-[50px] flex justify-center shadow p-[10px] rounded-[12px] bg-white"
                //     onClick={() => setQrModal(true)}
                //   >
                //     <svg
                //       width="34"
                //       height="34"
                //       viewBox="0 0 34 34"
                //       fill="none"
                //       xmlns="http://www.w3.org/2000/svg"
                //     >
                //       <path
                //         d="M4.25 9.20833C4.25 7.8933 4.77239 6.63213 5.70226 5.70226C6.63213 4.77239 7.8933 4.25 9.20833 4.25H11.849C12.2247 4.25 12.5851 4.39926 12.8507 4.66493C13.1164 4.93061 13.2657 5.29094 13.2657 5.66667C13.2657 6.04239 13.1164 6.40272 12.8507 6.6684C12.5851 6.93408 12.2247 7.08333 11.849 7.08333H9.20833C8.64475 7.08333 8.10425 7.30722 7.70573 7.70573C7.30722 8.10425 7.08333 8.64475 7.08333 9.20833V11.849C7.08333 12.2247 6.93408 12.5851 6.6684 12.8507C6.40272 13.1164 6.04239 13.2657 5.66667 13.2657C5.29094 13.2657 4.93061 13.1164 4.66493 12.8507C4.39926 12.5851 4.25 12.2247 4.25 11.849V9.20833ZM20.7343 5.66667C20.7343 5.29094 20.8836 4.93061 21.1493 4.66493C21.4149 4.39926 21.7753 4.25 22.151 4.25H24.7917C26.1067 4.25 27.3679 4.77239 28.2977 5.70226C29.2276 6.63213 29.75 7.8933 29.75 9.20833V11.849C29.75 12.2247 29.6007 12.5851 29.3351 12.8507C29.0694 13.1164 28.7091 13.2657 28.3333 13.2657C27.9576 13.2657 27.5973 13.1164 27.3316 12.8507C27.0659 12.5851 26.9167 12.2247 26.9167 11.849V9.20833C26.9167 8.64475 26.6928 8.10425 26.2943 7.70573C25.8958 7.30722 25.3553 7.08333 24.7917 7.08333H22.151C21.7753 7.08333 21.4149 6.93408 21.1493 6.6684C20.8836 6.40272 20.7343 6.04239 20.7343 5.66667ZM5.66667 20.7343C6.04239 20.7343 6.40272 20.8836 6.6684 21.1493C6.93408 21.4149 7.08333 21.7753 7.08333 22.151V24.7917C7.08333 25.3553 7.30722 25.8958 7.70573 26.2943C8.10425 26.6928 8.64475 26.9167 9.20833 26.9167H11.849C12.2247 26.9167 12.5851 27.0659 12.8507 27.3316C13.1164 27.5973 13.2657 27.9576 13.2657 28.3333C13.2657 28.7091 13.1164 29.0694 12.8507 29.3351C12.5851 29.6007 12.2247 29.75 11.849 29.75H9.20833C7.8933 29.75 6.63213 29.2276 5.70226 28.2977C4.77239 27.3679 4.25 26.1067 4.25 24.7917V22.151C4.25 21.7753 4.39926 21.4149 4.66493 21.1493C4.93061 20.8836 5.29094 20.7343 5.66667 20.7343ZM28.3333 20.7343C28.7091 20.7343 29.0694 20.8836 29.3351 21.1493C29.6007 21.4149 29.75 21.7753 29.75 22.151V24.7917C29.75 26.1067 29.2276 27.3679 28.2977 28.2977C27.3679 29.2276 26.1067 29.75 24.7917 29.75H22.151C21.7753 29.75 21.4149 29.6007 21.1493 29.3351C20.8836 29.0694 20.7343 28.7091 20.7343 28.3333C20.7343 27.9576 20.8836 27.5973 21.1493 27.3316C21.4149 27.0659 21.7753 26.9167 22.151 26.9167H24.7917C25.3553 26.9167 25.8958 26.6928 26.2943 26.2943C26.6928 25.8958 26.9167 25.3553 26.9167 24.7917V22.151C26.9167 21.7753 27.0659 21.4149 27.3316 21.1493C27.5973 20.8836 27.9576 20.7343 28.3333 20.7343ZM14.1667 9.91667H9.91667V14.1667H14.1667V19.8333H9.91667V24.0833H14.1667V19.8333H19.8333V24.0833H24.0833V19.8333H19.8333V14.1667H24.0833V9.91667H19.8333V14.1667H14.1667V9.91667Z"
                //         fill={Highlightcolor ? Highlightcolor : "black"}
                //       />
                //     </svg>
                //   </button>

                //   {card?.exchangeContact?.show ?
                //     <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
                //     : ""
                //   }

                // </div>
                ""
              )}
              {/*  --------------------------------- footer ---------------------------------  */}
            </div>
            {/* {preview ? (
              <div className="flex justify-center gap-[20px] fixed top-[90%] left-[44%]   ">
                {card?.exchangeContact?.show ?
                  <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
                  : ""
                }
                <button className="w-[50px] h-[50px] p-[15px] shadow-xl rounded-[12px]  bg-white" onClick={handleShare}>
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 20C14.1667 20 13.4583 19.7083 12.875 19.125C12.2917 18.5417 12 17.8333 12 17C12 16.8833 12.0083 16.7623 12.025 16.637C12.0417 16.5117 12.0667 16.3993 12.1 16.3L5.05 12.2C4.76667 12.45 4.45 12.646 4.1 12.788C3.75 12.93 3.38333 13.0007 3 13C2.16667 13 1.45833 12.7083 0.875 12.125C0.291667 11.5417 0 10.8333 0 10C0 9.16667 0.291667 8.45833 0.875 7.875C1.45833 7.29167 2.16667 7 3 7C3.38333 7 3.75 7.071 4.1 7.213C4.45 7.355 4.76667 7.55067 5.05 7.8L12.1 3.7C12.0667 3.6 12.0417 3.48767 12.025 3.363C12.0083 3.23833 12 3.11733 12 3C12 2.16667 12.2917 1.45833 12.875 0.875C13.4583 0.291667 14.1667 0 15 0C15.8333 0 16.5417 0.291667 17.125 0.875C17.7083 1.45833 18 2.16667 18 3C18 3.83333 17.7083 4.54167 17.125 5.125C16.5417 5.70833 15.8333 6 15 6C14.6167 6 14.25 5.92933 13.9 5.788C13.55 5.64667 13.2333 5.45067 12.95 5.2L5.9 9.3C5.93333 9.4 5.95833 9.51267 5.975 9.638C5.99167 9.76333 6 9.884 6 10C6 10.1167 5.99167 10.2377 5.975 10.363C5.95833 10.4883 5.93333 10.6007 5.9 10.7L12.95 14.8C13.2333 14.55 13.55 14.3543 13.9 14.213C14.25 14.0717 14.6167 14.0007 15 14C15.8333 14 16.5417 14.2917 17.125 14.875C17.7083 15.4583 18 16.1667 18 17C18 17.8333 17.7083 18.5417 17.125 19.125C16.5417 19.7083 15.8333 20 15 20Z"
                      fill="black"
                    />
                  </svg>
                </button>
                <button
                  className="w-[50px] h-[50px] p-[10px] shadow-xl rounded-[12px] bg-white"
                  onClick={() => setQrModal(true)}
                >
                  <svg
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.25 9.20833C4.25 7.8933 4.77239 6.63213 5.70226 5.70226C6.63213 4.77239 7.8933 4.25 9.20833 4.25H11.849C12.2247 4.25 12.5851 4.39926 12.8507 4.66493C13.1164 4.93061 13.2657 5.29094 13.2657 5.66667C13.2657 6.04239 13.1164 6.40272 12.8507 6.6684C12.5851 6.93408 12.2247 7.08333 11.849 7.08333H9.20833C8.64475 7.08333 8.10425 7.30722 7.70573 7.70573C7.30722 8.10425 7.08333 8.64475 7.08333 9.20833V11.849C7.08333 12.2247 6.93408 12.5851 6.6684 12.8507C6.40272 13.1164 6.04239 13.2657 5.66667 13.2657C5.29094 13.2657 4.93061 13.1164 4.66493 12.8507C4.39926 12.5851 4.25 12.2247 4.25 11.849V9.20833ZM20.7343 5.66667C20.7343 5.29094 20.8836 4.93061 21.1493 4.66493C21.4149 4.39926 21.7753 4.25 22.151 4.25H24.7917C26.1067 4.25 27.3679 4.77239 28.2977 5.70226C29.2276 6.63213 29.75 7.8933 29.75 9.20833V11.849C29.75 12.2247 29.6007 12.5851 29.3351 12.8507C29.0694 13.1164 28.7091 13.2657 28.3333 13.2657C27.9576 13.2657 27.5973 13.1164 27.3316 12.8507C27.0659 12.5851 26.9167 12.2247 26.9167 11.849V9.20833C26.9167 8.64475 26.6928 8.10425 26.2943 7.70573C25.8958 7.30722 25.3553 7.08333 24.7917 7.08333H22.151C21.7753 7.08333 21.4149 6.93408 21.1493 6.6684C20.8836 6.40272 20.7343 6.04239 20.7343 5.66667ZM5.66667 20.7343C6.04239 20.7343 6.40272 20.8836 6.6684 21.1493C6.93408 21.4149 7.08333 21.7753 7.08333 22.151V24.7917C7.08333 25.3553 7.30722 25.8958 7.70573 26.2943C8.10425 26.6928 8.64475 26.9167 9.20833 26.9167H11.849C12.2247 26.9167 12.5851 27.0659 12.8507 27.3316C13.1164 27.5973 13.2657 27.9576 13.2657 28.3333C13.2657 28.7091 13.1164 29.0694 12.8507 29.3351C12.5851 29.6007 12.2247 29.75 11.849 29.75H9.20833C7.8933 29.75 6.63213 29.2276 5.70226 28.2977C4.77239 27.3679 4.25 26.1067 4.25 24.7917V22.151C4.25 21.7753 4.39926 21.4149 4.66493 21.1493C4.93061 20.8836 5.29094 20.7343 5.66667 20.7343ZM28.3333 20.7343C28.7091 20.7343 29.0694 20.8836 29.3351 21.1493C29.6007 21.4149 29.75 21.7753 29.75 22.151V24.7917C29.75 26.1067 29.2276 27.3679 28.2977 28.2977C27.3679 29.2276 26.1067 29.75 24.7917 29.75H22.151C21.7753 29.75 21.4149 29.6007 21.1493 29.3351C20.8836 29.0694 20.7343 28.7091 20.7343 28.3333C20.7343 27.9576 20.8836 27.5973 21.1493 27.3316C21.4149 27.0659 21.7753 26.9167 22.151 26.9167H24.7917C25.3553 26.9167 25.8958 26.6928 26.2943 26.2943C26.6928 25.8958 26.9167 25.3553 26.9167 24.7917V22.151C26.9167 21.7753 27.0659 21.4149 27.3316 21.1493C27.5973 20.8836 27.9576 20.7343 28.3333 20.7343ZM14.1667 9.91667H9.91667V14.1667H14.1667V19.8333H9.91667V24.0833H14.1667V19.8333H19.8333V24.0833H24.0833V19.8333H19.8333V14.1667H24.0833V9.91667H19.8333V14.1667H14.1667V9.91667Z"
                      fill="black"
                    />
                  </svg>
                </button>

              </div>
            ) : (
              ""
            )} */}
          </div>
          {footerText && (
            <div className="">
              <Footer color={"#ffffff"} />
            </div>
          )}
        </div>

        {qrModal ? (
          <QRModal
            handleClose={handleClose}
            Highlightcolor={Highlightcolor}
            Textcolor={Textcolor}
          />
        ) : null}
      </div>
    </>
  );
}

export default DigitalTheme1;
